import React from "react";
import { UserCircle2, LogOut, History, Trophy, Gift, Coins } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";

// Top-right account control: "Sign in" when signed out, avatar menu when signed in.
export const AccountButton = ({ user, onSignIn, onLogout, onHistory, onPrizes, onInvite }) => {
  if (!user) {
    return (
      <button
        data-testid="account-signin-btn"
        onClick={onSignIn}
        className="flex items-center gap-1.5 whitespace-nowrap shrink-0 rounded-xl bg-[#10B981] text-[#0F172A] px-3 py-2 text-sm font-bold hover:-translate-y-0.5 transition-transform"
      >
        <UserCircle2 className="w-4 h-4" /> Sign in
      </button>
    );
  }
  const item = "flex items-center gap-2 cursor-pointer text-slate-200 focus:bg-white/10 focus:text-white";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid="account-menu-btn"
          aria-label="Account"
          className="w-10 h-10 rounded-full flex items-center justify-center font-display font-extrabold text-[#0F172A] border-2 border-white/20 hover:border-[#10B981] transition-colors overflow-hidden"
          style={{ background: "#10B981" }}
        >
          {user.picture ? <img src={user.picture} alt="" className="w-full h-full object-cover" /> : (user.username || "?").slice(0, 1).toUpperCase()}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="theme-light w-60 bg-[#1E293B] border-white/15 text-white" data-testid="account-menu">
        <DropdownMenuLabel className="font-normal">
          <div className="font-semibold text-white truncate" data-testid="account-menu-username">{user.username}</div>
          {user.contact_email && <div className="text-xs text-slate-400 truncate" data-testid="account-menu-email">{user.contact_email}</div>}
          <div className="mt-1.5 flex items-center gap-1.5 text-[#10B981] text-sm font-bold">
            <Coins className="w-4 h-4" /> £{Number(user.coins || 0).toLocaleString()} virtual
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem data-testid="account-menu-history" onSelect={onHistory} className={item}><History className="w-4 h-4" /> Game history</DropdownMenuItem>
        <DropdownMenuItem data-testid="account-menu-prizes" onSelect={onPrizes} className={item}><Trophy className="w-4 h-4" /> My prizes</DropdownMenuItem>
        <DropdownMenuItem data-testid="account-menu-invite" onSelect={onInvite} className={item}><Gift className="w-4 h-4" /> Invite & earn £30</DropdownMenuItem>
        <DropdownMenuSeparator className="bg-white/10" />
        <DropdownMenuItem data-testid="account-menu-logout" onSelect={onLogout} className={`${item} text-[#EF4444]`}><LogOut className="w-4 h-4" /> Log out</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default AccountButton;
